export default "__VITE_ASSET__70933879__"